<template>
  <div class="gm">
    <TopHead name="政务公告" />
    <!--banner轮播-->
    <van-swipe
      class="my-swipe"
      :autoplay="3000"
      lazy-render
    >
      <van-swipe-item
        v-for="(item,index) in bannerArr"
        :key="index"
        class="p_r"
        @click="bannerGo(item)"
      >
        <van-image
          fit="cover"
          :src="item.imgUrl"
        >
          <template #loading>
            <img
              src="../assets/img/img_loading.png"
              alt=""
            >
          </template>
        </van-image>
      </van-swipe-item>
      <template #indicator="{ active }">
        <div class="name_in p_r">
          <div
            v-if="active>-1"
            class="name"
          >
            {{ bannerArr[active].name }}
          </div>
          <div class="name_num t_a p_a">
            {{ active + 1 }}
          </div>
        </div>
      </template>
    </van-swipe>

    <!--列表-->
    <van-pull-refresh
      v-model="loading"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :immediate-check="false"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="list_item_gm">
          <div
            v-for="(item,index) in list"
            :key="index"
            class="d_f ali_c over_h"
            @click="$router.push('/gmDetail?id='+item.contentId)"
          >
            <van-image
              fit="cover"
              :src="item.cover"
            >
              <template #loading>
                <img
                  src="../assets/img/img_loading.png"
                  alt=""
                >
              </template>
            </van-image>
            <div class="flex_1">
              <div class="re_name">
                {{ item.title }}
              </div>
              <div class="name_sub">
                {{ item.synopsis }}
              </div>
              <div class="d_f ali_c j_s see_out">
                <span>{{ item.createDate.split(' ')[0] }}</span>
                <div>
                  <img
                    src="../assets/img/see_num.png"
                    alt=""
                  >
                  <span>{{ item.readNumber }}浏览</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
  export default {
    name: "Government",
    data() {
      return {
        refreshing:false,
        loading:true,
        finished:false,
        list:[],
        bannerArr:[],
        rateNum:1.1,
        params:{
          pageIndex:1,
          pageSize:10,
          data:{
            columnCode:'zwgg'
          }
        },
      }
    },
    created(){
      this.listLoad();
      this.getBanner();
    },
    methods: {
      bannerGo(row){
        if(row.interlinkage){
          if(row.backRequired){
            window.location.href = row.interlinkage;
          }else{
            this.$router.push(row.interlinkage)
          }
        }
      },
      listLoad(){

        this.loading = true;
        this.$api.getInfoContentList(this.params).then(res => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listLoad();
      },
      onLoad(){
        let me = this;
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listLoad();
      },
      //获取banner
      getBanner(){
        this.$api.getBanner({position:21}).then(res => {
          this.bannerArr = res.data;
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .list_item_gm{
    .see_out{
      img{
        width: 27px;
        margin-right: 9px;
      }
      padding-right: 62px;
    }
    .re_name{
      font-size: 30px;
      font-weight: bold;
      color: #3E3E3E;
      margin-bottom: 20px;
    }
    .name_sub{
      margin-bottom: 16px;
    }
    .re_name,.name_sub{
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    font-size: 26px;
    font-weight: 500;
    color: #8E8E8E;
    .van-image{
      margin-right: 35px;
      width: 240px;
      height: 200px;
      border-radius: 10px;
      overflow: hidden;
    }
    margin-bottom: 45px;
  }
  .my-swipe{
    .name_in{
      .name_num{
        right: 0;
        bottom: 0;
        background: url("../assets/img/gm_num.png") center center no-repeat;
        background-size: 100% 1PX;
        font-size: 26px;
        font-weight: 500;
        color: #3E3E3E;
        /*height: 20px;*/
        width: 254px;
      }
      font-size: 26px;
      font-weight: 500;
      color: #3E3E3E;
    }
    ::v-deep .van-swipe-item{
      width: 700px;
      height: 280px;
      margin-bottom: 17px;
    }
    margin-bottom: 56px;
  }
  .gm{
    padding: 85px 25px 0;
    height: 100vh;
    box-sizing: border-box;
    overflow: auto;
  }
</style>
